import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/lib/motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Renders simple text: "## " headings, "- " bullets, blank-line separated paragraphs.
export const RichText = ({ content }) => {
  const blocks = [];
  let list = null;
  content.split("\n").forEach((raw) => {
    const line = raw.trimEnd();
    if (line.startsWith("- ")) {
      if (!list) { list = []; blocks.push({ type: "ul", items: list }); }
      list.push(line.slice(2));
      return;
    }
    list = null;
    if (!line.trim()) return;
    if (line.startsWith("## ")) blocks.push({ type: "h2", text: line.slice(3) });
    else blocks.push({ type: "p", text: line });
  });
  return (
    <div className="space-y-4">
      {blocks.map((b, i) => {
        if (b.type === "h2") return <h2 key={i} className="font-serif text-2xl text-forest pt-6">{b.text}</h2>;
        if (b.type === "ul") return <ul key={i} className="list-disc pl-5 space-y-2 text-sm sm:text-base text-ink/80 leading-relaxed">{b.items.map((it, j) => <li key={j}>{it}</li>)}</ul>;
        return <p key={i} className="text-sm sm:text-base text-ink/80 leading-relaxed">{b.text}</p>;
      })}
    </div>
  );
};

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    axios.get(`${API}/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <div className="container-nb py-32 text-center font-serif text-2xl text-forest">Page not found.</div>;
  if (!page) return <div className="min-h-[60vh]" />;

  return (
    <div data-testid={`legal-page-${slug}`} className="py-16 sm:py-24">
      <div className="container-nb max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-mutedgreen hover:text-forest transition-colors"><ArrowLeft size={13} /> Home</Link>
        <Reveal>
          <p className="eyebrow mt-8 mb-4">Nutribest Superfoods</p>
          <h1 data-testid="legal-page-title" className="font-serif text-4xl sm:text-5xl text-forest leading-[1.05]">{page.title}</h1>
          {page.updated_at && <p className="text-xs text-mutedgreen mt-3">Last updated {new Date(page.updated_at).toLocaleDateString("en-IN", { dateStyle: "long" })}</p>}
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 bg-white border border-forest/10 rounded-3xl p-7 sm:p-12">
            <RichText content={page.content} />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
